/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { AIGeneralBlockCard } from '../../AIGeneralBlockCard';
import { Text } from '../../../atoms/Text/Text';
import './PartialFailureRendererStyles.scss';
const baseClass = 'qmb-ui-PartialFailureRenderer';
export function PartialFailureRenderer({ block }) {
    const pf = block;
    const sections = [
        {
            label: pf.title,
            content: (React.createElement("div", { className: baseClass },
                React.createElement(Text, { variant: "body" },
                    pf.succeeded_count,
                    " of ",
                    pf.total_count,
                    " succeeded, ",
                    pf.failed_count,
                    " failed")))
        },
        ...(pf.failures.length > 0
            ? [
                {
                    content: (React.createElement("ul", { className: `${baseClass}__failures` }, pf.failures.map((f, i) => (React.createElement("li", { key: i, className: `${baseClass}__failure` },
                        React.createElement(Text, { variant: "body" },
                            React.createElement("strong", null, f.label),
                            ": ",
                            f.reason))))))
                }
            ]
            : [])
    ];
    return React.createElement(AIGeneralBlockCard, { variant: "error", sections: sections });
}
